<template>
    <div class="container-tabs text-center">
        <v-btn v-for="tab in tabs" :key="tab.value"
               :class="['normal-btn primary-color', {'active-tab': currentTab === tab.value}]"
               depressed text
               @click="currentTab = tab.value">
            {{ tab.name }}
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "KimsaTabs",
    props: {
        tabs: {
            type: Array,
            default: () => [],
        },
        value: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            currentTab: null,
        }
    },
    mounted() {
        const vm = this
        vm.setDefaults()
    },
    methods: {
        setDefaults() {
            const vm = this
            if (vm.value) vm.currentTab = vm.value
        },
    },
    watch: {
        value() {
            this.setDefaults()
        },
        currentTab(val) {
            this.$emit('change', val)
        }
    }
}
</script>

<style scoped>

.container-tabs {
    background: #F9F9F9;
    border-radius: 10px;
    padding: 8px 16px;
}

.active-tab {
    background: #FFFFFF;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 6px;
}

</style>